import React from 'react';
import { Alert, Card, CardContent, Checkbox, Grid, Typography } from '@mui/material';
import { SERVICE_OPTIONS } from '../onboardingMapping.js';

export default function ServicesStep({ answers, errors, onChange }) {
  const toggle = id => onChange({
    ...answers,
    services: { ...answers.services, [id]: !answers.services[id] },
  });

  return (
    <>
      <Typography variant="h5" fontWeight={600} gutterBottom>What services do you offer?</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Select everything that applies. We'll only ask follow-up questions for the services you choose.
      </Typography>
      {errors.services && <Alert severity="error" sx={{ mb: 2 }}>{errors.services}</Alert>}
      <Grid container spacing={2}>
        {SERVICE_OPTIONS.map(option => {
          const selected = !!answers.services[option.id];
          return (
            <Grid item xs={12} sm={6} key={option.id}>
              <Card
                onClick={() => toggle(option.id)}
                sx={{
                  cursor: 'pointer', border: selected ? 2 : 1,
                  borderColor: selected ? 'primary.main' : 'divider',
                  backgroundColor: selected ? 'primary.50' : 'background.paper',
                  transition: 'all 0.15s ease-in-out',
                  '&:hover': { borderColor: 'primary.main' },
                }}
              >
                <CardContent sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', pb: '16px !important' }}>
                  <Checkbox checked={selected} onClick={e => e.stopPropagation()} onChange={() => toggle(option.id)} sx={{ p: 0 }} />
                  <span>
                    <Typography variant="subtitle1" fontWeight={600}>{option.label}</Typography>
                    <Typography variant="body2" color="text.secondary">{option.description}</Typography>
                  </span>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      {answers.services.longDistance && (
        <Alert severity="info" sx={{ mt: 2.5 }}>
          Long-distance moving is enabled — we'll ask where you provide it and how you price it in the next steps.
        </Alert>
      )}
    </>
  );
}
